/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentListChatResponse {
    getFixupPrototypeFunction() { return AgentListChatResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentListChatResponse>): AgentListChatResponse {
        let obj = Object.assign(new AgentListChatResponse(), model);
        AgentListChatResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentListChatResponse>): AgentListChatResponse {
        if (!model) return null;
        return AgentListChatResponse.newInstance(<AgentListChatResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentListChatResponse) {
        if (!obj) return;

        models.AgentListChatResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentListChatResponse): boolean {
        Object.setPrototypeOf(obj, AgentListChatResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

    /**
     * Whether the caller holds the share-chat capability (users read-or-higher via a DEFAULT role) in the listed tenant. Drives tab/button availability; sharing itself additionally requires chat ownership.
     */
    viewer_share_capability: boolean;

}
